import { Award, Code, Rocket, Users } from "lucide-react";

function About() {
  const highlights = [
    {
      icon: Code,
      title: "技術力",
      description: "最新技術のキャッチアップと実践的な適用",
    },
    {
      icon: Users,
      title: "チームリード",
      description: "技術指導とメンタリング経験",
    },
    {
      icon: Rocket,
      title: "プロジェクト推進",
      description: "要件定義から運用まで全工程を主導",
    },
    {
      icon: Award,
      title: "品質重視",
      description: "保守性・拡張性を考慮した設計",
    },
  ];

  return (
    <section
      id="about"
      className="bg-white px-6 py-16 md:px-12 md:py-24 lg:px-24"
    >
      <div className="fade-in-section mx-auto max-w-7xl">
        <div className="mb-10 text-center md:mb-16">
          <h2 className="mb-4 text-xl font-bold text-gray-900 md:text-2xl">
            プロフィール
          </h2>
          <div className="mx-auto h-1 w-20 bg-blue-600"></div>
        </div>

        <div className="mx-auto mb-12 max-w-3xl md:mb-16">
          <p className="mb-6 leading-relaxed text-gray-700">
            主にSaaS領域でフロントエンド／バックエンド／インフラまでを横断し、プロダクト開発をフルスタックにリードしてきました。現在はシニアエンジニアとして、技術選定やアーキテクチャ設計に加え、品質・開発速度・運用負荷のバランスを最適化する仕組みづくりを推進しています。
          </p>
          <p className="leading-relaxed text-gray-700">
            AWSを中心としたクラウドネイティブな設計・運用を強みとし、スケーラブルで変更に強い構成を設計・実装。アジャイル開発の推進、レビュー文化の醸成、技術的意思決定の透明化など、チームの生産性を継続的に高める取り組みも担っています。
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="fade-in-section rounded-lg bg-gray-50 p-6 text-center"
              style={{ transitionDelay: `${index * 50}ms` }}
            >
              <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-blue-100 text-blue-600">
                <item.icon size={32} />
              </div>
              <h3 className="mb-2 text-gray-900">{item.title}</h3>
              <p className="leading-relaxed text-gray-600">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
